export enum TabKeys {
  Missions = 'missions',
  Explore = 'explore',
  CoachingSession = 'coaching-sessions',
  CustomerComments = 'customer-comments',
  CoworkerReports = 'coworker-reports',
  Efficiency = 'efficiency',
}
